import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { toast } from "react-toastify";
import { Icon } from "@iconify/react";

import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";

import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import EmailOutlined from "@mui/icons-material/EmailOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PhoneIcon from "@mui/icons-material/Phone";
import SmsOutlined from "@mui/icons-material/SmsOutlined";
import formatPhoneNumber from "../Helper/formatPhoneNumber";
import { setMakeCall } from "../Store/Actions/CallAction";
import "./ContactCard.css";
import { useEffect } from "react";
import { type } from "@testing-library/user-event/dist/type";

export default function ContactCard({
  data,
  contactList,
  setIsContactDetailsModalShown,
  setSelected,
  isLinkSource,
  isLinking,
  setIsMergeWarningDialogShown,
  setMergeDestination,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [CallType, setCallType] = useState(false);
  const [CallMsg, setMsgType] = useState(false);
  const [filteredPhone, setFilteredPhone] = useState([]);
  const [filteredMsg, setFilteredMsg] = useState([]);
  const dispatch = useDispatch();
  const { CurrentState } = useSelector((state) => state.auth);
  const open = Boolean(anchorEl);
  const open2 = Boolean(anchorEl2);

  // Get unique contact type values (only show one item per contact type)
  const uniqueContactList = [
    ...new Map(
      contactList?.map((contact) => [contact["PhoneTypeID"], contact])
    ).values(),
  ];

  // Sort the contact list to show mobile and email first before other types
  const uniqueContactListSorted = [
    ...uniqueContactList.filter(
      ({ PhoneTypeID }) => PhoneTypeID === 9 || PhoneTypeID === 32
    ),
    ...uniqueContactList.filter(
      ({ PhoneTypeID }) => PhoneTypeID !== 9 && PhoneTypeID !== 32
    ),
  ];

  //Split the number for calls and message
  useEffect(() => {
    var filternumber = contactList.filter((contact) => contact.PhoneNo);

    var filter2 = filternumber.filter((contact) =>
      contact.PhoneNo.match(/^[0-9]*$/g)
    );

    var unmatchedString = filternumber.filter(function (el) {
      return !filter2.includes(el);
    });

    let lengthCall = filter2.length;
    let lengthMsg = unmatchedString.length;

    setFilteredPhone(filter2);
    setFilteredMsg(unmatchedString);

    if (lengthCall < 2) {
      setCallType(true);
    }

    if (lengthMsg < 2) {
      setMsgType(true);
    }
  }, []);

  return (
    <div
      className={`contact_Card ${isLinkSource ? "link-source" : ""}`}
      onClick={(e) => {
        if (isLinking && isLinkSource) {
          e.stopPropagation();
        } else if (isLinking && !isLinkSource) {
          setIsMergeWarningDialogShown(true);

          setMergeDestination({
            name: data.FirstName ? data.FirstName : "Unknown Contact",
            id: data.ContactID,
          });
        } else {
          setSelected(data.ContactID);
          setIsContactDetailsModalShown(true);
        }
      }}
    >
      <section className="contact_card-header">
        {(!data.FirstName || data?.FirstName?.trim().length === 0) &&
        !data.LastName ? ( // Show "Unknown Contact" if FirstName and LastName is empty
          <p className="contact-name">Unknown Contact</p>
        ) : (
          <p className="contact-name">
            {data.FirstName + " " + (data.LastName ? data.LastName : "")}
          </p>
        )}

        {data.ContactRef && <p className="ref-code">Ref. {data.ContactRef}</p>}
      </section>

      <section className="card-body">
        {uniqueContactListSorted.map((contact, index) => {
          // Only show 3 contacts and hide contacts with value '0'
          return index < 3 && contact.PhoneNo !== "0" ? (
            <div className="item" key={contact.RecordID}>
              {(() => {
                switch (contact.PhoneTypeID) {
                  case 1: // Business
                  case 2:
                  case 3:
                    return <Icon icon="mdi:briefcase" width="15" height="15" />;

                  case 9: // Mobile
                  case 10: // Mobile2
                    return <PhoneIcon />;

                  case 11:
                    return (
                      // Other
                      <Icon icon="mdi:more-circle" width="15" height="15" />
                    );

                  case 15:
                    return (
                      // Econ (emergency contact)
                      <Icon
                        icon="material-symbols:contact-emergency"
                        width="15"
                        height="15"
                      />
                    );

                  case 32:
                    return <AlternateEmailIcon />; // Email

                  // For later case (Whatsapp)
                  /* case 'whatsapp': return (
                    <img
                      src={WhatsappSmallIcon}
                      alt="" 
                    />
                  ); */

                  case 33:
                    return (
                      // Twitter
                      <Icon icon="mdi:twitter" width="15" height="15" />
                    );

                  case 34:
                    return (
                      // Facebook
                      <Icon icon="mdi:facebook" width="15" height="15" />
                    );

                  case 35:
                    return (
                      // Instagram
                      <Icon icon="ri:instagram-line" width="15" height="15" />
                    );

                  default:
                    break;
                }
              })()}

              <p className="value">
                {contact.PhoneTypeID === 1 || // Business
                contact.PhoneTypeID === 9 || // Mobile
                contact.PhoneTypeID === 10 || // Mobile2
                contact.PhoneTypeID === 11 || // Other
                contact.PhoneTypeID === 15 // Econ (emergency contact)
                  ? `${formatPhoneNumber(contact.PhoneNo)}`
                  : contact.PhoneNo}
              </p>
            </div>
          ) : null;
        })}
      </section>

      <section className="card-footer" onClick={(e) => e.stopPropagation()}>
        {CallMsg ? (
          <Tooltip
            arrow
            // title="Message"
            title="Select Contact"
          >
            <button
              className="message-button"
              onClick={() => {
                // toast.warn("Chat is not available for this contact.", {
                //   autoClose: 3000,
                // });

                setSelected(data.ContactID);
                setIsContactDetailsModalShown(true);
              }}
            >
              <SmsOutlined />
            </button>
          </Tooltip>
        ) : (
          <Tooltip title="Select Contact" arrow>
            <button
              className="message-button"
              onClick={(a) => {
                // setAnchorEl2(a.currentTarget)

                setSelected(data.ContactID);
                setIsContactDetailsModalShown(true);
              }}
            >
              <SmsOutlined />

              {/* <Icon
                height="20"
                icon="material-symbols:arrow-drop-down"
                width="20"
              /> */}
            </button>
          </Tooltip>
        )}
        <Menu
          anchorEl={anchorEl2}
          open={open2}
          anchorOrigin={{ horizontal: 0, vertical: 50 }}
          className="more-menu"
          onClose={() => setAnchorEl2(null)}
        >
          {filteredMsg?.map((contact, index, arr) => {
            return (
              <MenuItem key={contact.RecordID}>
                {(() => {
                  switch (contact.PhoneTypeID) {
                    case 1: // Business
                    case 9: // Mobile
                    case 10: // Mobile2
                    case 15: // Econ (emergency contact)
                      return (
                        <>
                          <PhoneIcon />
                          {contact.phoneNo}
                        </>
                      );

                    // For later case (Whatsapp)
                    /* case 'whatsapp': return (
                      <>
                        <SmsOutlined />
                        Message
                      </>
                    ); */

                    case 32:
                      return (
                        // Email
                        <>
                          <EmailOutlined />
                          {contact.PhoneNo}
                        </>
                      );

                    default:
                      return (
                        // Email
                        <>
                          <Icon
                            height="20"
                            icon="ant-design:message-filled"
                            width="20"
                          />
                          {contact.PhoneNo}
                        </>
                      );
                  }
                })()}
              </MenuItem>
            );
          })}
        </Menu>

        {CallType ? (
          <Tooltip
            arrow
            // title="Call"
            title="Select Contact"
          >
            <button
              className="call-button"
              onClick={() => {
                // if (contactList.some((contact) => contact.PhoneTypeID === 9)) {
                //   dispatch(
                //     setMakeCall({
                //       phoneNo: contactList.find(
                //         (contact) => contact.PhoneTypeID === 9
                //       ).PhoneNo,
                //       agentStatus: CurrentState,
                //       goToACW: data.CampaignID ? true : false,
                //       contactID: data.ContactID,
                //       campaignID: data.CampaignID,

                //       phoneTypeID: contactList.find(
                //         (contact) => contact.PhoneTypeID === 9
                //       ).PhoneTypeID,
                //     })
                //   );
                // } else {
                //   toast.warn("Call is not available for this contact.", {
                //     autoClose: 3000,
                //   });
                // }

                setSelected(data.ContactID);
                setIsContactDetailsModalShown(true);
              }}
            >
              <PhoneIcon />
            </button>
          </Tooltip>
        ) : (
          <Tooltip
            arrow
            // title="Select Number"
            title="Select Contact"
          >
            <button
              className="call-button"
              onClick={(e) => {
                // setAnchorEl(e.currentTarget)

                setSelected(data.ContactID);
                setIsContactDetailsModalShown(true);
              }}
            >
              <PhoneIcon />

              {/* <Icon
                height="20"
                icon="material-symbols:arrow-drop-down"
                width="20"
              /> */}
            </button>
          </Tooltip>
        )}
        <Menu
          anchorEl={anchorEl}
          open={open}
          anchorOrigin={{ horizontal: -70, vertical: 50 }}
          className="more-menu"
          onClose={() => setAnchorEl(null)}
        >
          {filteredPhone?.map((contact) => {
            return (
              <MenuItem
                key={contact.RecordID}
                onClick={() => {
                  setAnchorEl(null);

                  dispatch(
                    setMakeCall({
                      phoneNo: contact.PhoneNo,
                      agentStatus: CurrentState,
                      goToACW: data.CampaignID ? true : false,
                      contactID: data.ContactID,
                      campaignID: data.CampaignID,
                      phoneTypeID: contact.PhoneTypeID,
                    })
                  );
                }}
              >
                <PhoneIcon /> {contact.PhoneNo}
              </MenuItem>
            );
          })}
        </Menu>
      </section>
    </div>
  );
}
